module.exports = "#title-container {\n  margin-top: 72px;\n  margin-left: 223px; }\n\n.aliveMessage {\n  display: inline-block;\n  font-size: 20px;\n  color: #939393;\n  width: 390px; }\n\n#refresh {\n  margin-top: 60px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/is-alive/is-alive.component.scss
// module id = ./src/app/shared/components/is-alive/is-alive.component.scss
// module chunks = main